export var clientPassthroughMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                nameToDisplay: item.nameToDisplay,
                apikey: item.apikey,
                url: item.url,
                urlNew: item.urL_NEW,
                treminalId: item.terminalid,
                treminalAssignTo: item.terminaL_ASSIGNTO,
                isActive: item.isactive,
                urlEncrypted: item.urL_ENCRYPTED,
                empCodeTxt: item.empCodeTxt,
            };
        });
    }
    return result;
};
